module.exports = __webpack_public_path__ + "static/media/mix.a080ebeb.png";